export const KEY_AUTH_TOKEN = "aff.token";
export const KEY_USER_INFO = "aff.userInfo";
